export default "__VITE_ASSET__da6a66be__"